module.exports = __webpack_public_path__ + "static/image13@2x-6c317ed9778cf7239deb420c618855f9.png";